/**
 * Translate Uploadly app strings
 */
function translateUploadly() {
  const selectors = {
    // Tab panels
    container: '.uploadcare--panel',
    widgetText: '#uploadcare--widget__text',
    menuTabFile: '.uploadcare--menu__item_tab_file',
    menuTabCamera: '.uploadcare--menu__item_tab_camera',
    menuTabPreview: '.uploadcare--menu__item_tab_preview',
    
    // Local files tab
    dragDropFileShow: '.uploadcare--dragging__show',
    dragDropFileTitle: '.uploadcare--draganddrop__supported .uploadcare--text_size_extra-large',
    dragDropFileTitleSmall: '.uploadcare--draganddrop__supported .uploadcare--text_size_small.uploadcare--text_muted',
    dragDropFileSelectedHeader: '.uploadcare--panel_multiple .uploadcare--preview__content',
    dragDropFileSelectedChooseMoreBtn: '.uploadcare--preview__content #uploadcare__add_more_files_btn',
    dropFileTitle: '.uploadcare--draganddrop_supported .uploadcare--text_size_extra-large.uploadcare--dragging__show',
    chooseFileBtn: '.uploadcare--tab_name_file .uploadcare--dragging__hide.uploadcare--tab__action-button',

    // Camera tab
    cameraTabTitle: '.uploadcare--tab_name_camera .uploadcare--tab__title',
    cameraTabRetryBtn: '.uploadcare--tab_name_camera .uploadcare--camera__button.uploadcare--camera__button_type_retry',
    cameraControlsTakePhoto: '.uploadcare--tab_name_camera .uploadcare--camera__button_type_capture',
    cameraControlsMirror: '.uploadcare--tab_name_camera .uploadcare--camera__button_type_mirror',
    
    // Footer
    footerShowFilesBtn: '.uploadcare--footer .uploadcare--panel__show-files',
    footerShowFilesMsg: '.uploadcare--footer .uploadcare--panel__message',
    footerShowFilesDoneBtn: '.uploadcare--footer .uploadcare--panel__done',
    footerFileAddedRemoveAllBtn: '.uploadcare--tab__footer .uploadcare--footer__button.uploadcare--preview__back',
    footerFileAddedDone: '.uploadcare--tab__footer .uploadcare--preview__done',
  }

  const elements = {
    special: {
      widgetText: document.querySelector(selectors.widgetText),
    },
    main: {
      cameraTabTitle: document.querySelector(selectors.cameraTabTitle),
      cameraTabRetryBtn: document.querySelector(selectors.cameraTabRetryBtn),
      dragDropFileShow: document.querySelector(selectors.dragDropFileShow),
      dragDropFileTitle: document.querySelector(selectors.dragDropFileTitle),
      dropFileTitle: document.querySelector(selectors.dropFileTitle),
      dragDropFileTitleSmall: document.querySelector(selectors.dragDropFileTitleSmall),
      dragDropFileSelectedChooseMoreBtn: document.querySelector(selectors.dragDropFileSelectedChooseMoreBtn),
      chooseFileBtn: document.querySelector(selectors.chooseFileBtn),
      
      cameraControlsTakePhoto: document.querySelector(selectors.cameraControlsTakePhoto),
      cameraControlsMirror: document.querySelector(selectors.cameraControlsMirror),
      
      footerShowFilesBtn: document.querySelector(selectors.footerShowFilesBtn),
      footerShowFilesDoneBtn: document.querySelector(selectors.footerShowFilesDoneBtn),
      footerShowFilesMsg: document.querySelector(selectors.footerShowFilesMsg),
      footerFileAddedRemoveAllBtn: document.querySelector(selectors.footerFileAddedRemoveAllBtn),
      footerFileAddedDone: document.querySelector(selectors.footerFileAddedDone),
    },
    pseudo: {
      menuTabFile: document.querySelector(selectors.menuTabFile),
      menuTabCamera: document.querySelector(selectors.menuTabCamera),
      menuTabPreview: document.querySelector(selectors.menuTabPreview),
      dragDropFileSelectedHeader: document.querySelector(selectors.dragDropFileSelectedHeader),
    }
  }

  const stringsMap = {
    widgetText: theme.strings.uploadly.no_group_error,
    menuTabFile: theme.strings.uploadly.local_files.label,
    menuTabCamera: theme.strings.uploadly.camera.label,
    menuTabPreview: theme.strings.uploadly.tab_preview_label,

    dragDropFileTitle: theme.strings.uploadly.local_files.drag_and_drop,
    dropFileTitle: theme.strings.uploadly.local_files.drop_a_file,
    dragDropFileTitleSmall: theme.strings.uploadly.local_files.or,
    chooseFileBtn: theme.strings.uploadly.local_files.choose_local_file,
    dragDropFileSelectedHeader: theme.strings.uploadly.local_files.choose_image_from_list,
    dragDropFileSelectedChooseMoreBtn: theme.strings.uploadly.local_files.choose_more_files_button,
    
    cameraTabTitle: theme.strings.uploadly.camera.file_from_web_camera,
    cameraTabRetryBtn: theme.strings.uploadly.camera.request_permissions_again,
    cameraControlsTakePhoto: theme.strings.uploadly.camera.controls_take_photo,
    cameraControlsMirror: theme.strings.uploadly.camera.mirror,

    footerShowFilesBtn: theme.strings.uploadly.show_files,
    footerShowFilesMsg: theme.strings.uploadly.you_chose_files,
    footerShowFilesDoneBtn: theme.strings.uploadly.done,
    footerFileAddedRemoveAllBtn: theme.strings.uploadly.local_files.remove_all,
    footerFileAddedDone: theme.strings.uploadly.local_files.add,
  }

  Object.entries(elements.main).map(element => {
    if (!element[1] || !stringsMap[element[0]]) {
      return;
    }
    
    element[1].innerHTML = stringsMap[element[0]].replace('{{number}}', element[1].innerHTML.match(/\d/g))
  })

  Object.entries(elements.pseudo).map(element => {
    if (!element[1] || !stringsMap[element[0]]) {
      return;
    }
    
    element[1].setAttribute('title', stringsMap[element[0]]) 
  })

  if (elements.special.widgetText.textContent == 'Can’t create file group') {
    elements.special.widgetText.textContent = stringsMap.widgetText
  }

  console.log(elements);
  console.log(stringsMap);
}

const observer = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1 && node.classList.contains('uploadcare--panel')) {
          translateUploadly();
        }
      }
    }
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});